// src/app/app.ts
import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SupportWidgetComponent } from '@/app/shared/components/support-widget/support-widget';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SupportWidgetComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('emio-app');
}